"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasAdminAccess = exports.BASIC_AND_ABOVE = exports.ADMIN_AND_ABOVE = void 0;
const internal_feature_flag_enum_1 = require("./internal-feature-flag.enum");
/** @deprecated use Authorized({ internalFeatureFlags: [InternalFeatureFlag.AdminAccess] }) instead */
exports.ADMIN_AND_ABOVE = { internalFeatureFlags: [internal_feature_flag_enum_1.InternalFeatureFlag.AdminAccess] };
/** @deprecated leave Authorized() empty instead */
exports.BASIC_AND_ABOVE = {};
/**
 * Given a list of internal featureflags for a user, return if they contain AdminAccess
 * @returns boolean true if the user has admin access or not
 */
function hasAdminAccess(user) {
    const { internalFeatureFlags } = user;
    if (!internalFeatureFlags) {
        throw new Error("User does not have internalFeatureFlags property");
    }
    return internalFeatureFlags.some((ff) => {
        return ff.toString() === internal_feature_flag_enum_1.InternalFeatureFlag.AdminAccess.toString();
    });
}
exports.hasAdminAccess = hasAdminAccess;
